import React from 'react'
import OperationsTemplate from '../../templates/Operations/OperationsTemplate'

const Operations = () => {
  return (
     <OperationsTemplate />
  )
}

export default Operations